import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, combineLatestWith, of, mergeMap, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { JSONAtaObject } from 'src/app/features/shared/helper-classes';

/* data storage interface for ngrx */
import { DataStorage } from 'src/app/features/data-stores/data-storage.interface';

import * as lodash from 'lodash';
import { Logout } from 'src/app/features/data-stores/auth-data-store/state/auth-data-store.actions';

// prettier-ignore
// #region customCode: page-component-ts__package-import__end

// #endregion customCode: page-component-ts__package-import__end

@Component({
  selector: 'liife-tenant-dashboard-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit, OnDestroy {

  // prettier-ignore
  // #region customCode: page-component-ts__ui-page-component-class__start

  // #endregion customCode: page-component-ts__ui-page-component-class__start


  /* Component: Menu 2 */
  menu_2: any = {
    config: { "mode": "vertical", "items": [{ "label": "Users", "actionBehavior": "router", "redirectUrl": "/members", "level": "1", "children": [], "isExpanded": false }, { "label": "Tenants", "actionBehavior": "router", "redirectUrl": "/tenants", "level": "1", "children": [], "isExpanded": false }], "backgroundColor": "var(--component-header-background-color)" }, isCollapsed: false, paddingValue: "0px", menuPlacement: "center", isDisabled: null, showLabels: true, activeItem: null, currentSubmenuOnly: null,
  };

  /* Component: Heading 1 */
  heading_1: any = {
    content: "Liife Core Tenant Admin", type: "h4", typography: {},
    colorSettings: {},
  };


  /* state subscriptions */
  subscriptions: Subscription[];

  /* visibility condition variables */


  constructor(
    private store: Store<DataStorage>
  ) {
    // prettier-ignore
    // #region customCode: page-component-ts__constructor__start

    // #endregion customCode: page-component-ts__constructor__start

    // prettier-ignore
    // #region customCode: page-component-ts__constructor__end

    // #endregion customCode: page-component-ts__constructor__end
  }

  ngOnInit(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__start

    // #endregion customCode: page-component-ts__ui-page-on-init__start

    this.subscribeToData();
    this.subscribeToDataSelectors();

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__end

    // #endregion customCode: page-component-ts__ui-page-on-init__end
  }

  ngOnDestroy(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__start

    // #endregion customCode: page-component-ts__ui-page-on-destroy__start

    this.subscriptions?.forEach(subscription => subscription.unsubscribe());

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__end

    // #endregion customCode: page-component-ts__ui-page-on-destroy__end
  }

  subscribeToData() {
    this.subscriptions = [
    ];
  }

  subscribeToDataSelectors() {
    const dataSelectors = [

    ];
    this.subscriptions.push(...dataSelectors);
  }

  onLogout() {
    localStorage.removeItem('DS');
    localStorage.removeItem('DSR');
    localStorage.removeItem('token');
    this.store.dispatch(Logout());
  }


  // prettier-ignore
  // #region customCode: page-component-ts__ui-page-component-class__end

  // #endregion customCode: page-component-ts__ui-page-component-class__end
}
